import React from 'react';
import { DescriptionColumn } from './description-column';
import { ProviderColumn } from './provider-column';
import { Row } from './row';

export const SalesRow = ({ providers, salesLabel, salesProviderValues }) => (
  <Row paddingBottom={'10px'}>
    <DescriptionColumn fontSize={16} padding={'10px 0px 0px 0px'}>
      {salesLabel}
    </DescriptionColumn>
    {providers.map((provider) => {
      const value = salesProviderValues.find((values) => values.providerID === provider.id)?.value || '';
      return <ProviderColumn key={`providerSales_${provider.id}`}>{value}</ProviderColumn>;
    })}
  </Row>
);
